import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutResizeEventService {
  readonly resizeEndedEvent$ = new Subject<void>();
}
